import {
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toString30pk9tzaqopn as toString_0,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
  isInterface3d6p8outrmvmk as isInterface,
  CancellationException3b36o9qz53rgr as CancellationException,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Result3t1vadv16kmzk as Result,
  emptyMapr06gerzljqtm as emptyMap,
  VOID3gxj6tk5isa35 as VOID,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  hashCodeq5arwsb9dgti as hashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  constructCallableReference23y65rf941mch as constructCallableReference,
  Exceptiondt2hlxn7j7vw as Exception,
  emptyList1g2z5xcrvp2zy as emptyList,
  to2cs3ny02qtbcb as to,
  mapOf2zpbbmyqk8xpf as mapOf,
  first58ocm7j58k3q as first,
  getKClass3t8tygqu4lcxf as getKClass,
  Delegates_instance168r08gkbpepf as Delegates_instance,
  lazy2hsh8ze7j6ikd as lazy,
  Long2qws0ah9gnpki as Long,
  emptySetcxexqki71qfa as emptySet,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  plus310ted5e4i90h as plus,
  listOfvhqybd2zx248 as listOf,
  createThis2j2avj17cvnv2 as createThis,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance2t6whcwokm4cc as Companion_getInstance,
  Handshakes7sujajuvjgm as Handshake,
  Failure2wqvlrjpa8l54 as Failure,
  StreamMessage1e9va7cm3qf8q as StreamMessage,
  CallSuccess2l9ustajavsnp as CallSuccess,
  deserialize15kk7mfgp3ocj as deserialize,
  StreamCancel1cxd0d8l4r06h as StreamCancel,
  StreamFinished17y6z5thm8g9h as StreamFinished,
  buildContextual34zooulbn4ib4 as buildContextual,
  decodeMessageDatad5q5piqbwv7j as decodeMessageData,
  CallExceptionqh88lj8kp459 as CallException,
  CallDatate73dsq212t6 as CallData,
  CallableParametersSerializer1k5n8tzz1b8bg as CallableParametersSerializer,
  unsupportedSerialFormatError2csqaxsmaf5vz as unsupportedSerialFormatError,
  CallDataBinaryupe51whtnnt5 as CallDataBinary,
  CallDataString54rlcd0zej8o as CallDataString,
  serializeException2dx7mm3wofz2y as serializeException,
  CallType_Method_getInstance2dbh40ur48cef as CallType_Method_getInstance,
  CancellationType_ENDPOINT_getInstance6iufvg18q1fp as CancellationType_ENDPOINT_getInstance,
  KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance23127b0ayxu6x as KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance,
  CancellationType_REQUEST_getInstance4vacwxnpf4yu as CancellationType_REQUEST_getInstance,
  KrpcPluginKey_CANCELLATION_TYPE_getInstance3keaurjiu7uwn as KrpcPluginKey_CANCELLATION_TYPE_getInstance,
  StreamMessageBinary21ruu70xkf9uf as StreamMessageBinary,
  StreamMessageString39p72u9yibcdc as StreamMessageString,
  rpcInternalObjectId1j81fi2yp6iv3 as rpcInternalObjectId,
  cancellationType2thefpqbdfadt as cancellationType,
  sendCancellation2qvnp88e4j4hc as sendCancellation,
  sendCancellation$default3ne1rl72wh1kl as sendCancellation$default,
  handleGenericMessage1qkadapt8s9wk as handleGenericMessage,
  KrpcEndpoint1s5gofkbk9zxj as KrpcEndpoint,
  StreamSerializer1zsx0m41iechn as StreamSerializer,
  KrpcConnectorsn3f9h83qubb as KrpcConnector,
  ServiceCall2c26s9o99x7xs as ServiceCall,
  Protocol_instance2ojjlc2yk2h1r as Protocol_instance,
  Generic_instance1ic2aqjydnzrh as Generic_instance,
} from './kotlinx-rpc-krpc-krpc-core.mjs';
import {
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ChannelResult__exceptionOrNull_impl_16ei302x9fo9thjhzif as ChannelResult__exceptionOrNull_impl_16ei30,
  _ChannelResult___get_isClosed__impl__mg7kuu3a26on4apn4j4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  ChannelResult__getOrThrow_impl_od1axsdky2zm58n02y as ChannelResult__getOrThrow_impl_od1axs,
  _ChannelResult___get_isFailure__impl__nz6ehu2fj0qoa5trbx8 as _ChannelResult___get_isFailure__impl__nz6ehu,
  ensureActivem48bojk66pw0 as ensureActive,
  FlowCollector26clgpmzihvke as FlowCollector,
  get_job2zvlvce9o9a29 as get_job,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  launch1c91vkjzdi9sd as launch,
  supervisorScope3mi0bhexh7bxt as supervisorScope,
  cancelAndJoin21f2rd386nyt8 as cancelAndJoin,
  Channel3r72atmcithql as Channel,
  Channel3g65mgfma68ln as Channel_0,
  coroutineScope39ukucf23mhsm as coroutineScope,
  Flow3375h4584bu3w as Flow,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Mutex16li1l0asjv17 as Mutex,
  cancel2ztysw4v4hav6 as cancel,
  first1gbp9d21tksw3 as first_0,
  flow3tazazxj2t7g4 as flow,
} from './kotlinx-coroutines-core.mjs';
import {
  BinaryFormat3f3aelhmz0ro1 as BinaryFormat,
  StringFormat2r2ka8mzcb3mi as StringFormat,
  KSerializerzf77vz1967fq as KSerializer,
  SerializersModuleBuilderfxsfdohcdipc as SerializersModuleBuilder,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { Method20rthexa6dr04 as Method } from './kotlinx-rpc-core.mjs';
import { atomic$long$129k9zwo6n9ogd as atomic$long$1 } from './kotlinx-atomicfu.mjs';
import { Companion_getInstance1nbjfh65ymx8 as Companion_getInstance_0 } from './kotlinx-rpc-krpc-krpc-logging.mjs';
import {
  RpcInternalConcurrentHashMap298ok532k8jut as RpcInternalConcurrentHashMap,
  getOrNull367y7bf53uq6w as getOrNull,
  RpcInternalThreadLocal9wlt57iy5wdn as RpcInternalThreadLocal,
} from './kotlinx-rpc-utils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class sam$kotlinx_coroutines_flow_FlowCollector$0 {
  constructor(function_0) {
    this.a90_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.a90_1(value, $completion);
  }
  p5() {
    return this.a90_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class KrpcClient {
  constructor() {
    this.t8y_1 = false;
    this.u8y_1 = Delegates_instance.wq();
    var tmp = this;
    tmp.v8y_1 = lazy(KrpcClient$config$delegate$lambda(this));
    this.w8y_1 = false;
    this.x8y_1 = false;
    var tmp_0 = this;
    tmp_0.y8y_1 = lazy(KrpcClient$internalScope$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.z8y_1 = lazy(KrpcClient$connector$delegate$lambda(this));
    this.a8z_1 = null;
    this.b8z_1 = atomic$long$1(new Long(0, 0));
    this.c8z_1 = Companion_getInstance_0().c8m(rpcInternalObjectId(this, []));
    this.d8z_1 = CompletableDeferred();
    this.e8z_1 = RpcInternalConcurrentHashMap();
    this.f8z_1 = RpcInternalConcurrentHashMap();
    this.g8z_1 = Mutex();
    this.h8z_1 = new ClientStreamContext(this.a8z_1);
    var tmp_2 = this;
    tmp_2.i8z_1 = lazy(KrpcClient$serialFormat$delegate$lambda(this));
  }
  f90(message) {
    if (!this.t8y_1) {
      return Unit_instance;
    }
    var tmp = this.k8z();
    cancel(tmp, message == null ? 'Client closed' : message);
  }
  g90(message, $super) {
    message = message === VOID ? null : message;
    var tmp;
    if ($super === VOID) {
      this.f90(message);
      tmp = Unit_instance;
    } else {
      tmp = $super.f90.call(this, message);
    }
    return tmp;
  }
  k8z() {
    var tmp0 = this.y8y_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('internalScope', 1, tmp, KrpcClient$_get_internalScope_$ref_yje8i2(), null);
    return tmp0.k3();
  }
  v8r() {
    return _get_connector__ygexcs(this);
  }
  w8r() {
    var tmp0_elvis_lhs = getOrNull(this.d8z_1);
    return tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
  }
  *h90(call, $completion) {
    return yield* first_0(this.i90(call), $completion);
  }
  i90(call) {
    return flow(KrpcClient$callServerStreaming$slambda(this, call));
  }
  *a8s(message, $completion) {
    var type = cancellationType(message);
    if ((type == null ? -1 : type.w1_1) === 0) {
      this.x8y_1 = true;
      cancel(this.k8z(), 'Closing client after server cancellation');
    } else {
      this.c8z_1.y8l(KrpcClient$handleCancellation$lambda(type));
    }
    return Unit_instance;
  }
}
class Companion {
  constructor() {
    this.j90_1 = 'stream:';
  }
}
class ClientStreamContext {
  constructor(connectionId) {
    this.o8z_1 = connectionId;
    this.p8z_1 = RpcInternalConcurrentHashMap();
    this.q8z_1 = new RpcInternalThreadLocal();
    this.r8z_1 = new RpcInternalThreadLocal();
    this.s8z_1 = atomic$long$1(new Long(0, 0));
  }
  t8z(callId, serviceId, body) {
    try {
      this.q8z_1.m8l(callId);
      this.r8z_1.m8l(serviceId);
      return body();
    }finally {
      this.q8z_1.s7();
      this.r8z_1.s7();
    }
  }
  k90(value, elementKind) {
    var tmp0_elvis_lhs = this.q8z_1.a1v();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'No call id';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var callId = tmp;
    var tmp1_elvis_lhs = this.r8z_1.a1v();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message_0 = 'No service id';
      throw IllegalStateException.o(toString(message_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var serviceId = tmp_0;
    var streamId = 'stream:' + this.s8z_1.atomicfu$getAndIncrement$long().toString();
    var stream = new StreamCall(callId, streamId, value, isInterface(elementKind, KSerializer) ? elementKind : THROW_CCE(), this.o8z_1, serviceId);
    var tmp_1 = listOf(stream);
    this.p8z_1.f8l(callId, tmp_1, ClientStreamContext$registerClientStream$lambda);
    return streamId;
  }
}
class ClientStreamSerializer extends StreamSerializer {
  constructor(context, elementType) {
    super();
    this.o90_1 = context;
    this.p90_1 = elementType;
    var tmp = this;
    tmp.q90_1 = lazy(ClientStreamSerializer$descriptor$delegate$lambda(this));
  }
  dz() {
    var tmp0 = this.q90_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, ClientStreamSerializer$_get_descriptor_$ref_ylxa1a(), null);
    return tmp0.k3();
  }
  fz(decoder) {
    // Inline function 'kotlin.error' call
    var message = 'This method must not be called. Please report to the developer.';
    throw IllegalStateException.o(toString(message));
  }
  r90(encoder, value) {
    var id = this.o90_1.k90(value, this.p90_1);
    encoder.t14(id);
  }
  ez(encoder, value) {
    return this.r90(encoder, (!(value == null) ? isInterface(value, Flow) : false) ? value : THROW_CCE());
  }
}
class KrpcClientConnector {
  constructor(connector) {
    return new.target.s90(connector);
  }
  static s90(connector) {
    var $this = createThis(this);
    $this.l8z_1 = connector;
    return $this;
  }
  static c90(serialFormat, transport, config) {
    return this.s90(new KrpcConnector(serialFormat, transport, config, false));
  }
  *e90(serviceTypeString, callId, $completion) {
    yield* this.l8z_1.s8r(new ServiceCall(serviceTypeString, callId), $completion);
    return Unit_instance;
  }
  *d90(serviceTypeString, callId, subscription, $completion) {
    var tmp = new ServiceCall(serviceTypeString, callId);
    yield* this.l8z_1.t8r(tmp, KrpcClientConnector$subscribeToCallResponse$slambda(subscription), $completion);
    return Unit_instance;
  }
  *n8z(subscription, $completion) {
    var tmp = Protocol_instance;
    yield* this.l8z_1.t8r(tmp, KrpcClientConnector$subscribeToProtocolMessages$slambda(subscription), $completion);
    return Unit_instance;
  }
  *m8z(subscription, $completion) {
    var tmp = Generic_instance;
    yield* this.l8z_1.t8r(tmp, KrpcClientConnector$subscribeToGenericMessages$slambda(subscription), $completion);
    return Unit_instance;
  }
  *g8q(message, $completion) {
    yield* this.l8z_1.g8q(message, $completion);
    return Unit_instance;
  }
  u8r(message) {
    this.l8z_1.u8r(message);
  }
  r8r() {
    return this.l8z_1.t8p_1;
  }
}
class StreamCall {
  constructor(callId, streamId, stream, elementSerializer, connectionId, serviceId) {
    this.u8z_1 = callId;
    this.v8z_1 = streamId;
    this.w8z_1 = stream;
    this.x8z_1 = elementSerializer;
    this.y8z_1 = connectionId;
    this.z8z_1 = serviceId;
  }
  toString() {
    return 'StreamCall(callId=' + this.u8z_1 + ', streamId=' + this.v8z_1 + ', stream=' + toString(this.w8z_1) + ', elementSerializer=' + toString(this.x8z_1) + ', connectionId=' + toString_0(this.y8z_1) + ', serviceId=' + toString_0(this.z8z_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.u8z_1);
    result = imul(result, 31) + getStringHashCode(this.v8z_1) | 0;
    result = imul(result, 31) + hashCode(this.w8z_1) | 0;
    result = imul(result, 31) + hashCode(this.x8z_1) | 0;
    result = imul(result, 31) + (this.y8z_1 == null ? 0 : this.y8z_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z8z_1 == null ? 0 : this.z8z_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StreamCall))
      return false;
    if (!(this.u8z_1 === other.u8z_1))
      return false;
    if (!(this.v8z_1 === other.v8z_1))
      return false;
    if (!equals(this.w8z_1, other.w8z_1))
      return false;
    if (!equals(this.x8z_1, other.x8z_1))
      return false;
    if (!equals(this.y8z_1, other.y8z_1))
      return false;
    if (!equals(this.z8z_1, other.z8z_1))
      return false;
    return true;
  }
}
//endregion
function _set_transport__8b3ozo($this, _set____db54di) {
  var tmp = KMutableProperty1;
  var tmp_0 = KrpcClient$_get_transport_$ref_owvc20();
  return $this.u8y_1.br($this, getPropertyCallableRef('transport', 1, tmp, tmp_0, KrpcClient$_set_transport_$ref_9p3tjo()), _set____db54di);
}
function _get_transport__kzqrew($this) {
  var tmp = KMutableProperty1;
  var tmp_0 = KrpcClient$_get_transport_$ref_owvc20();
  return $this.u8y_1.zq($this, getPropertyCallableRef('transport', 1, tmp, tmp_0, KrpcClient$_set_transport_$ref_9p3tjo()));
}
function _get_config__hi7kzb($this) {
  var tmp0 = $this.v8y_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('config', 1, tmp, KrpcClient$_get_config_$ref_26wa95(), null);
  return tmp0.k3();
}
function checkTransportReadiness($this) {
  if (!$this.t8y_1) {
    // Inline function 'kotlin.error' call
    var message = 'Internal error, please contact developers for the support. Transport is not initialized, first scope access must come from an RPC request.';
    throw IllegalStateException.o(toString(message));
  }
}
function _get_connector__ygexcs($this) {
  var tmp0 = $this.z8y_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('connector', 1, tmp, KrpcClient$_get_connector_$ref_hjmzqk(), null);
  return tmp0.k3();
}
function *initializeAndAwaitHandshakeCompletion($this, $completion) {
  if (!$this.t8y_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.g8z_1;
    yield* this_0.y2a(null, $completion);
    try {
      $l$block: {
        if ($this.t8y_1) {
          break $l$block;
        }
        _set_transport__8b3ozo($this, yield* $this.j8z($completion));
        $this.t8y_1 = true;
        $this.k8z();
        var tmp = _get_connector__ygexcs($this);
        yield* tmp.m8z(KrpcClient$handleGenericMessage$ref($this), $completion);
        var tmp_0 = _get_connector__ygexcs($this);
        yield* tmp_0.n8z(KrpcClient$handleProtocolMessage$ref($this), $completion);
        var tmp0 = _get_connector__ygexcs($this);
        // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
        var message = new Handshake(Companion_getInstance().j8s_1);
        try {
          yield* tmp0.g8q(message, $completion);
        } catch ($p) {
          if ($p instanceof ClosedSendChannelException) {
            var e = $p;
          } else {
            throw $p;
          }
        }
      }
    }finally {
      this_0.k2a(null);
    }
  }
  yield* $this.d8z_1.m1q($completion);
  return Unit_instance;
}
function handleProtocolMessage($this, message) {
  if (message instanceof Handshake) {
    $this.a8z_1 = message.x8q_1;
    $this.d8z_1.l1t(message.w8q_1);
  } else {
    if (message instanceof Failure) {
      $this.c8z_1.z8l(KrpcClient$handleProtocolMessage$lambda(message));
      if (!$this.d8z_1.z1m()) {
        $this.d8z_1.k1t(IllegalStateException.o('Server failed to process protocol message: ' + toString_0(message.u8s_1)));
      }
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function *consumeAndEmitServerMessages($this, $receiver, channel, $completion) {
  $l$loop: while (true) {
    var element = (yield* channel.o22($completion)).q21_1;
    if (_ChannelResult___get_isClosed__impl__mg7kuu(element)) {
      var tmp0_elvis_lhs = ChannelResult__exceptionOrNull_impl_16ei30(element);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var ex = tmp;
      throw ex;
    }
    if (!_ChannelResult___get_isFailure__impl__nz6ehu(element)) {
      var result = ChannelResult__getOrThrow_impl_od1axs(element).zw_1;
      // Inline function 'kotlin.fold' call
      var exception = Result__exceptionOrNull_impl_p6xea9(result);
      if (exception == null) {
        var value = _Result___get_value__impl__bjfvqg(result);
        yield* $receiver.k24(value, $completion);
      } else {
        throw exception;
      }
    }
  }
  return Unit_instance;
}
function *handleServerStreamingMessage($this, message, channel, callable, $completion) {
  if (isInterface(message, CallData)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Unexpected message';
    throw IllegalStateException.o(toString(message_0));
  } else {
    if (message instanceof CallException) {
      var cause = deserialize(message.w8u_1);
      channel.w22(cause);
      channel.n1n(CancellationException.p('Call failed', cause));
    } else {
      var tmp;
      if (isInterface(message, CallSuccess)) {
        tmp = true;
      } else {
        tmp = isInterface(message, StreamMessage);
      }
      if (tmp) {
        // Inline function 'kotlin.runCatching' call
        var tmp_0;
        try {
          var serializerResult = buildContextual(_get_serialFormat__ahugkg($this).l10(), callable.t8n());
          // Inline function 'kotlin.Companion.success' call
          var value = decodeMessageData(_get_serialFormat__ahugkg($this), serializerResult, message);
          tmp_0 = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var value_0 = tmp_0;
        yield* channel.j22(new Result(new Result(value_0) instanceof Result ? value_0 : THROW_CCE()), $completion);
      } else {
        if (message instanceof StreamFinished) {
          channel.y22();
        } else {
          if (message instanceof StreamCancel) {
            var cause_0 = deserialize(message.d8w_1);
            channel.w22(cause_0);
            channel.n1n(CancellationException.p('Stream cancelled', cause_0));
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  return Unit_instance;
}
function serializeRequest($this, callId, call, callable, serialFormat, pluginParams) {
  pluginParams = pluginParams === VOID ? emptyMap() : pluginParams;
  var parametersSerializer = new CallableParametersSerializer(callable, serialFormat.l10());
  var tmp;
  if (isInterface(serialFormat, StringFormat)) {
    var stringValue = $this.h8z_1.t8z(callId, call.k8n_1, KrpcClient$serializeRequest$lambda(serialFormat, parametersSerializer, call));
    tmp = new CallDataString(callId, call.h8n_1.l8n(), call.i8n_1, toMessageCallType($this, callable), stringValue, $this.a8z_1, call.k8n_1, pluginParams);
  } else {
    if (isInterface(serialFormat, BinaryFormat)) {
      var binaryValue = $this.h8z_1.t8z(callId, call.k8n_1, KrpcClient$serializeRequest$lambda_0(serialFormat, parametersSerializer, call));
      tmp = new CallDataBinary(callId, call.h8n_1.l8n(), call.i8n_1, toMessageCallType($this, callable), binaryValue, $this.a8z_1, call.k8n_1, pluginParams);
    } else {
      unsupportedSerialFormatError(serialFormat);
    }
  }
  return tmp;
}
function *handleOutgoingStream($this, outgoingStream, serialFormat, serviceTypeString, $completion) {
  var failure = null;
  try {
    var tmp0_flow = outgoingStream.w8z_1;
    yield* collectAndSendOutgoingStream($this, serialFormat, tmp0_flow, serviceTypeString, outgoingStream, $completion);
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      ensureActive($this.k8z());
      failure = e;
      throw e;
    } else {
      if ($p instanceof Error) {
        var cause = $p;
        failure = cause;
        throw cause;
      } else {
        throw $p;
      }
    }
  }
  finally {
    if (!(failure == null)) {
      var serializedReason = serializeException(failure);
      var message = new StreamCancel(outgoingStream.u8z_1, serviceTypeString, outgoingStream.v8z_1, serializedReason, outgoingStream.y8z_1, outgoingStream.z8z_1);
      // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
      var this_0 = _get_connector__ygexcs($this);
      try {
        yield* this_0.g8q(message, $completion);
      } catch ($p_0) {
        if ($p_0 instanceof ClosedSendChannelException) {
          var e_0 = $p_0;
        } else {
          throw $p_0;
        }
      }
    }
  }
  var message_0 = new StreamFinished(outgoingStream.u8z_1, serviceTypeString, outgoingStream.v8z_1, outgoingStream.y8z_1, outgoingStream.z8z_1);
  yield* $this.v8r().g8q(message_0, $completion);
  return Unit_instance;
}
function *collectAndSendOutgoingStream($this, serialFormat, flow, serviceTypeString, outgoingStream, $completion) {
  var tmp = KrpcClient$collectAndSendOutgoingStream$slambda(serialFormat, outgoingStream, serviceTypeString, $this);
  yield* flow.j24(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp), $completion);
  return Unit_instance;
}
function _get_serialFormat__ahugkg($this) {
  var tmp0 = $this.i8z_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('serialFormat', 1, tmp, KrpcClient$_get_serialFormat_$ref_3wl2qa(), null);
  return tmp0.k3();
}
function toMessageCallType($this, $receiver) {
  var tmp0_subject = $receiver.u8n();
  var tmp;
  if (isInterface(tmp0_subject, Method)) {
    tmp = CallType_Method_getInstance();
  } else {
    noWhenBranchMatchedException();
  }
  return tmp;
}
function KrpcClient$_get_transport_$ref_owvc20() {
  return constructCallableReference((p0) => _get_transport__kzqrew(p0), 1, 0, 42);
}
function KrpcClient$_set_transport_$ref_9p3tjo() {
  return constructCallableReference((p0, p1) => {
    _set_transport__8b3ozo(p0, p1);
    return Unit_instance;
  }, 2, 0, 43);
}
function KrpcClient$config$delegate$lambda(this$0) {
  return () => this$0.b90();
}
function KrpcClient$_get_config_$ref_26wa95() {
  return constructCallableReference((p0) => _get_config__hi7kzb(p0), 1, 0, 44);
}
function KrpcClient$internalScope$delegate$lambda$lambda(this$0) {
  return (it) => {
    var tmp;
    try {
      if (!this$0.w8y_1 && !this$0.x8y_1) {
        this$0.x8r(CancellationType_ENDPOINT_getInstance(), null, null, true);
      }
      this$0.w8y_1 = true;
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    finally {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = this$0.e8z_1.y4().p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var cause = CancellationException.n('Client cancelled');
        element.w22(cause);
        element.n1n(cause);
      }
      this$0.e8z_1.a5();
    }
    return Unit_instance;
  };
}
function KrpcClient$internalScope$delegate$lambda(this$0) {
  return () => {
    checkTransportReadiness(this$0);
    var context = SupervisorJob(get_job(_get_transport__kzqrew(this$0).d1m()));
    var tmp = get_job(context);
    tmp.g1n(KrpcClient$internalScope$delegate$lambda$lambda(this$0));
    return CoroutineScope(context);
  };
}
function KrpcClient$_get_internalScope_$ref_yje8i2() {
  return constructCallableReference((p0) => p0.k8z(), 1, 0, 45);
}
function KrpcClient$connector$delegate$lambda(this$0) {
  return () => {
    checkTransportReadiness(this$0);
    return KrpcClientConnector.c90(_get_config__hi7kzb(this$0).z8o_1.j7e(), _get_transport__kzqrew(this$0), _get_config__hi7kzb(this$0).a8p_1);
  };
}
function KrpcClient$_get_connector_$ref_hjmzqk() {
  return constructCallableReference((p0) => _get_connector__ygexcs(p0), 1, 0, 46);
}
function KrpcClient$handleGenericMessage$ref(p0) {
  return constructCallableReference(function *(p0_0, $completion) {
    return yield* p0.z8r(p0_0, $completion);
  }, 1, 1, 47, 'handleGenericMessage', [p0]);
}
function KrpcClient$handleProtocolMessage$ref(p0) {
  return constructCallableReference(function *(p0_0, $completion) {
    var tmp0 = p0;
    handleProtocolMessage(tmp0, p0_0);
    return Unit_instance;
  }, 1, 5, 48, VOID, [p0]);
}
function KrpcClient$handleProtocolMessage$lambda($message) {
  return () => 'Server [' + toString_0($message.t8s_1) + '] failed to process protocol message ' + toString_0($message.u8s_1) + ': ' + $message.s8s_1;
}
function KrpcClient$callServerStreaming$slambda$slambda(this$0, $callId, $channel, $callable) {
  return constructCallableReference(function *(message, $completion) {
    var tmp;
    if (this$0.f8z_1.i8l($callId)) {
      return Unit_instance;
    }
    yield* /*#__NOINLINE__*/handleServerStreamingMessage(this$0, message, $channel, $callable, $completion);
    return Unit_instance;
  }, 1);
}
function KrpcClient$callServerStreaming$slambda$slambda$slambda$slambda$slambda(this$0, $it, $call) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/handleOutgoingStream(this$0, $it, _get_serialFormat__ahugkg(this$0), $call.h8n_1.l8n(), $completion);
    return Unit_instance;
  }, 1);
}
function KrpcClient$callServerStreaming$slambda$slambda$slambda$slambda(this$0, $callId, $call) {
  return constructCallableReference(function *($this$supervisorScope, $completion) {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = this$0.h8z_1.p8z_1.r7c($callId);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = (tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs).p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp = CoroutineName.b1u('client-stream-' + $call.k8n_1.toString() + '-' + $callId + '-' + element.v8z_1);
      launch($this$supervisorScope, tmp, VOID, KrpcClient$callServerStreaming$slambda$slambda$slambda$slambda$slambda(this$0, element, $call));
    }
    return Unit_instance;
  }, 1);
}
function KrpcClient$callServerStreaming$slambda$slambda$slambda(this$0, $callId, $call) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* supervisorScope(KrpcClient$callServerStreaming$slambda$slambda$slambda$slambda(this$0, $callId, $call), $completion);
    return Unit_instance;
  }, 1);
}
function KrpcClient$callServerStreaming$slambda$slambda_0($call, $callId, this$0, $this_flow, $channel) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp = CoroutineName.b1u('client-stream-root-' + $call.k8n_1.toString() + '-' + $callId);
    var clientStreamsJob = launch($this$coroutineScope, tmp, VOID, KrpcClient$callServerStreaming$slambda$slambda$slambda(this$0, $callId, $call));
    var tmp_0;
    try {
      tmp_0 = yield* /*#__NOINLINE__*/consumeAndEmitServerMessages(this$0, $this_flow, $channel, $completion);
    }finally {
      yield* cancelAndJoin(clientStreamsJob, $completion);
      this$0.h8z_1.p8z_1.h8l($callId);
    }
    return Unit_instance;
  }, 1);
}
function KrpcClient$callServerStreaming$slambda(this$0, $call) {
  return constructCallableReference(function *($this$flow, $completion) {
    var tmp;
    if (this$0.w8y_1) {
      // Inline function 'kotlin.error' call
      var message = 'RpcClient was cancelled';
      throw IllegalStateException.o(toString(message));
    }
    yield* /*#__NOINLINE__*/initializeAndAwaitHandshakeCompletion(this$0, $completion);
    var id = this$0.b8z_1.atomicfu$incrementAndGet$long();
    var tmp0_elvis_lhs = $call.h8n_1.m8n($call.i8n_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message_0 = "Unexpected callable '" + $call.i8n_1 + "' for " + $call.h8n_1.l8n() + ' service';
      throw IllegalStateException.o(toString(message_0));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var callable = tmp_0;
    var callId = toString_0(this$0.a8z_1) + ':' + callable.h1() + ':' + id.toString();
    var channel = Channel();
    var tmp_1;
    try {
      this$0.e8z_1.e8l(callId, isInterface(channel, Channel_0) ? channel : THROW_CCE());
      if (this$0.w8y_1) {
        this$0.e8z_1.h8l(callId);
        // Inline function 'kotlin.error' call
        var message_1 = 'RpcClient was cancelled';
        throw IllegalStateException.o(toString(message_1));
      }
      var request = serializeRequest(this$0, callId, $call, callable, _get_serialFormat__ahugkg(this$0), mapOf(to(KrpcPluginKey_NON_SUSPENDING_SERVER_FLOW_MARKER_getInstance(), '')));
      var tmp_2 = _get_connector__ygexcs(this$0);
      var tmp_3 = $call.h8n_1.l8n();
      yield* tmp_2.d90(tmp_3, callId, KrpcClient$callServerStreaming$slambda$slambda(this$0, callId, channel, callable), $completion);
      yield* _get_connector__ygexcs(this$0).g8q(request, $completion);
      tmp_1 = yield* coroutineScope(KrpcClient$callServerStreaming$slambda$slambda_0($call, callId, this$0, $this$flow, channel), $completion);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof CancellationException) {
        var e = $p;
        if (!this$0.w8y_1) {
          this$0.f8z_1.e8l(callId, $call.h8n_1.l8n());
          this$0.y8r(CancellationType_REQUEST_getInstance(), $call.h8n_1.l8n(), callId);
          yield* _get_connector__ygexcs(this$0).e90($call.h8n_1.l8n(), callId, $completion);
          this$0.f8z_1.h8l(callId);
        }
        throw e;
      } else {
        throw $p;
      }
    }
    finally {
      channel.y22();
      channel.a23();
      this$0.e8z_1.h8l(callId);
      yield* _get_connector__ygexcs(this$0).e90($call.h8n_1.l8n(), callId, $completion);
    }
    return Unit_instance;
  }, 1);
}
function KrpcClient$handleCancellation$lambda($type) {
  return () => 'Unsupported ' + toString(KrpcPluginKey_CANCELLATION_TYPE_getInstance()) + ' ' + toString_0($type) + ' for client, ' + "only 'endpoint' type may be sent by a server";
}
function KrpcClient$serializeRequest$lambda($serialFormat, $parametersSerializer, $call) {
  return () => $serialFormat.m10($parametersSerializer, $call.j8n_1);
}
function KrpcClient$serializeRequest$lambda_0($serialFormat, $parametersSerializer, $call) {
  return () => $serialFormat.j10($parametersSerializer, $call.j8n_1);
}
function KrpcClient$collectAndSendOutgoingStream$slambda($serialFormat, $outgoingStream, $serviceTypeString, this$0) {
  return constructCallableReference(function *(it, $completion) {
    var tmp0_subject = $serialFormat;
    var tmp;
    if (isInterface(tmp0_subject, StringFormat)) {
      var stringData = $serialFormat.m10($outgoingStream.x8z_1, it);
      tmp = new StreamMessageString($outgoingStream.u8z_1, $serviceTypeString, $outgoingStream.v8z_1, stringData, $outgoingStream.y8z_1, $outgoingStream.z8z_1);
    } else {
      if (isInterface(tmp0_subject, BinaryFormat)) {
        var binaryData = $serialFormat.j10($outgoingStream.x8z_1, it);
        tmp = new StreamMessageBinary($outgoingStream.u8z_1, $serviceTypeString, $outgoingStream.v8z_1, binaryData, $outgoingStream.y8z_1, $outgoingStream.z8z_1);
      } else {
        unsupportedSerialFormatError($serialFormat);
      }
    }
    var message = tmp;
    // Inline function 'kotlinx.rpc.krpc.internal.sendMessageChecked' call
    var this_0 = this$0.v8r();
    try {
      yield* this_0.g8q(message, $completion);
    } catch ($p) {
      if ($p instanceof ClosedSendChannelException) {
        var e = $p;
        throw CancellationException.p('Request cancelled', e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 1);
}
function KrpcClient$serialFormat$delegate$lambda$lambda(this$0) {
  return (it) => {
    var tmp = first(it);
    return new ClientStreamSerializer(this$0.h8z_1, isInterface(tmp, KSerializer) ? tmp : THROW_CCE());
  };
}
function KrpcClient$serialFormat$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlinx.serialization.modules.SerializersModule' call
    var builder = new SerializersModuleBuilder();
    var tmp = getKClass(Flow);
    builder.o1k(tmp, KrpcClient$serialFormat$delegate$lambda$lambda(this$0));
    var module_0 = builder.i19();
    return _get_config__hi7kzb(this$0).z8o_1.o8l(module_0);
  };
}
function KrpcClient$_get_serialFormat_$ref_3wl2qa() {
  return constructCallableReference((p0) => _get_serialFormat__ahugkg(p0), 1, 0, 49);
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function ClientStreamContext$registerClientStream$lambda(old, new_0) {
  return plus(old, new_0);
}
function ClientStreamSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return ($this$buildClassSerialDescriptor) => {
    $this$buildClassSerialDescriptor.oz(this$0.m8y_1, this$0.o8y_1);
    return Unit_instance;
  };
}
function ClientStreamSerializer$descriptor$delegate$lambda(this$0) {
  return () => buildClassSerialDescriptor('ClientStreamSerializer', [], ClientStreamSerializer$descriptor$delegate$lambda$lambda(this$0));
}
function ClientStreamSerializer$_get_descriptor_$ref_ylxa1a() {
  return constructCallableReference((p0) => p0.dz(), 1, 0, 50);
}
function KrpcClientConnector$subscribeToCallResponse$slambda($subscription) {
  return constructCallableReference(function *(it, $completion) {
    yield* $subscription(it, $completion);
    return Unit_instance;
  }, 1);
}
function KrpcClientConnector$subscribeToProtocolMessages$slambda($subscription) {
  return constructCallableReference(function *(it, $completion) {
    yield* $subscription(it, $completion);
    return Unit_instance;
  }, 1);
}
function KrpcClientConnector$subscribeToGenericMessages$slambda($subscription) {
  return constructCallableReference(function *(it, $completion) {
    yield* $subscription(it, $completion);
    return Unit_instance;
  }, 1);
}
//region block: post-declaration
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
protoOf(KrpcClient).x8r = sendCancellation;
protoOf(KrpcClient).y8r = sendCancellation$default;
protoOf(KrpcClient).z8r = handleGenericMessage;
initMetadataForClass(KrpcClient, 'KrpcClient', VOID, VOID, [KrpcEndpoint], [0, 1, 2, 3, 4]);
initMetadataForCompanion(Companion);
initMetadataForClass(ClientStreamContext, 'ClientStreamContext');
initMetadataForClass(ClientStreamSerializer, 'ClientStreamSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(KrpcClientConnector, 'KrpcClientConnector', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(StreamCall, 'StreamCall');
//endregion
//region block: init
Companion_instance_0 = new Companion();
//endregion
//region block: exports
export {
  KrpcClient as KrpcClient30gq6xrrg2pfu,
};
//endregion
